import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom";
import { updateRefreshCardData } from "../../redux/dripData";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useDispatch } from "react-redux";
import apiServiceHandler from "../../service/apiService";

const DetailsModal = ({ isOpen, onClose, cardData }) => {

  const {id} = useParams()
  const dispatch = useDispatch()

  const [cardTitle, setCardTitle] = useState("")

  useEffect(() => {
    if (isOpen && cardData?.title) {
      setCardTitle(cardData?.title || "")
    }
  }, [isOpen, cardData])

  const updateCardTitle = async () => {
    try {
      const response = await apiServiceHandler("PATCH", `api/drip-compaign/${id}`, {
        title: cardTitle,
      });
      if (response?.status) {
        toastr.success(response?.message);
        dispatch(updateRefreshCardData(true))
        onClose()
      }
    } catch (error) {
      console.log("Failed to toggle the campaign. Please try again!")
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
          <svg
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="icon__svg"
            preserveAspectRatio="xMidYMid meet"
            style={{ width: "20px", height: "20px", marginTop: '2px' }}
          >
            <path
              d="M3.5 0a3 3 0 00-3 3v12.015c0 1.645 1.355 3 3 3h13c1.645 0 3-1.355 3-3V3a3 3 0 00-3-3h-13zm-.25 2a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm3 0h8a.75.75 0 010 1.5h-8a.75.75 0 010-1.5zM2.5 5.5h15v9.515c0 .564-.436 1-1 1h-13c-.564 0-1-.436-1-1V5.5zM4.75 7a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-3A.75.75 0 009.25 7h-4.5zm7.5 0a.75.75 0 00-.75.75v6c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-6a.75.75 0 00-.75-.75h-3zm-7.5 6a.751.751 0 100 1.5h4.5a.751.751 0 100-1.5h-4.5z"
              fill="#29353D"
            ></path>
          </svg>
          <span>Details</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Name</div>
            <div className="form-input__wrapper">
              <input type="text" className="form-input__input" value={cardTitle} onChange={(e) => setCardTitle(e.target.value)} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button className="send-invite__btn" onClick={updateCardTitle}>
          <span className="send-invite-button__label">Save</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailsModal;
